import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/DynamicPanel.css';
import '../styles/Support.css';

const Support = ({ onClose }) => {
  const { t } = useLanguage();

  return (
    <div className="dynamic-panel">
      {/* Power Panel Container */}
      <div className="support-power-panel">

        {/* Power Headline */}
        <div className="support-power-headline">
          <div className="support-headline-left">
            <span className="support-headline-icon">🛟</span>
            <h2 className="support-headline-title">Support</h2>
          </div>
        </div>

        {/* Info Panel */}
        <div className="support-info-panel">
          <div className="info-panel-header">
            <h3 className="info-panel-title">Benötigen Sie Hilfe?</h3>
          </div>
          <p className="info-panel-text">
            Unser öffentliches GitHub-Repository ist die zentrale Anlaufstelle für Support, Fehlermeldungen und Feature-Wünsche.
          </p>
          <p className="info-panel-hint">
            ⚡ Fehler melden oder Fragen stellen über GitHub Issues
          </p>
          <p className="info-panel-subhint">
            Für komplexe Fälle kann eine Rückfrage nötig sein.
          </p>
        </div>

        {/* GitHub Support CTA Card */}
        <div className="ai-support-cta-card">
          <div className="cta-card-header">
            <div className="cta-card-icon">🐙</div>
            <h3 className="cta-card-title">GitHub Repository</h3>
          </div>

          <p className="cta-card-description">
            Öffentliche Anlaufstelle für Support – Issues erstellen, Bugs melden, den Quellcode einsehen.
          </p>

          <a
            href="https://github.com/overLines/MyBoki.Me"
            target="_blank"
            rel="noopener noreferrer"
            className="support-cta-btn"
          >
            <span className="cta-icon">🔗</span>
            <span className="cta-text">Zum GitHub Repository</span>
          </a>
        </div>

      </div>
    </div>
  );
};

export default Support;